module.exports = __webpack_public_path__ + "media/images/icons/country_flags/as-c7e4903aecacf54a21ab46995b15c08e.svg";